import { render, staticRenderFns } from "./MockTestView.vue?vue&type=template&id=4a154f95&scoped=true&"
import script from "./MockTestView.vue?vue&type=script&lang=js&"
export * from "./MockTestView.vue?vue&type=script&lang=js&"
import style0 from "./MockTestView.vue?vue&type=style&index=0&id=4a154f95&scoped=true&lang=css&"
import style1 from "./MockTestView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a154f95",
  null
  
)

export default component.exports